import { Injectable } from '@angular/core';
import { ServiceAppointmentDeclinedMpviCode } from '@quorum/models/xs-resource';
import { createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { ApiService } from '@quorum/api';
import { map } from 'rxjs/operators';
import {
  GetServiceAppointmentDeclinedOperationsFromServer,
  GetServiceAppointmentDeclinedOperationsFromServerSuccess,
  ServiceAppointmentDeclinedOperationsEntityActionTypes,
  CreateServiceAppointmentDeclinedOperationsOnServer,
  CreateServiceAppointmentDeclinedOperationsOnServerSuccess,
  DeleteSelectedAppointmentDeclinedMpviFromServerSuccess,
  DeleteSelectedAppointmentDeclinedMpviFromServer,
  UpdateSelectedAppointmentDeclinedMpviOnServer,
  UpdateSelectedAppointmentDeclinedMpviOnServerSuccess,
} from './service-appointment-declined-operations.actions';

@Injectable()
export class ServiceAppointmentDeclinedOperationsEntityEffects {
  
  getServiceAppointmentDeclinedOperationsFromServer = createEffect(() => this.dataPersistence.fetch(
    ServiceAppointmentDeclinedOperationsEntityActionTypes.GetServiceAppointmentDeclinedOperationsFromServer,
    {
      run: (action: GetServiceAppointmentDeclinedOperationsFromServer, state: any) => {
        return this.apiService
          .get<ServiceAppointmentDeclinedMpviCode[]>(`v/1/fixed-operations/service-appointment-declined-mpvi-codes`, {
            params: action.payload,
          })
          .pipe(
            map((serviceAppointmentDeclinedOperations) => {
              return new GetServiceAppointmentDeclinedOperationsFromServerSuccess(serviceAppointmentDeclinedOperations);
            })
          );
      },
      onError: (action: GetServiceAppointmentDeclinedOperationsFromServer, error) => {
        console.error('Error', error);
      },
    }
  ));

  
  createServiceAppointmentDeclinedOperationsOnServer = createEffect(() => this.dataPersistence.pessimisticUpdate(
    ServiceAppointmentDeclinedOperationsEntityActionTypes.CreateServiceAppointmentDeclinedOperationsOnServer,
    {
      run: (action: CreateServiceAppointmentDeclinedOperationsOnServer, state: any) => {
        return this.apiService
          .post<ServiceAppointmentDeclinedMpviCode>(
            `v/1/fixed-operations/service-appointment-declined-mpvi-codes`,
            action.payload
          )
          .pipe(
            map(
              (declinedService: ServiceAppointmentDeclinedMpviCode) =>
                new CreateServiceAppointmentDeclinedOperationsOnServerSuccess(declinedService)
            )
          );
      },
      onError: (action: CreateServiceAppointmentDeclinedOperationsOnServer, error) => {
        console.error('Error', error);
      },
    }
  ));

  
  updateSelectedAppointmentDeclinedMpviOnServer = createEffect(() => this.dataPersistence.pessimisticUpdate(
    ServiceAppointmentDeclinedOperationsEntityActionTypes.UpdateSelectedAppointmentDeclinedMpviOnServer,
    {
      run: (action: UpdateSelectedAppointmentDeclinedMpviOnServer, state: any) => {
        return this.apiService
          .put<ServiceAppointmentDeclinedMpviCode>(
            `v/1/fixed-operations/service-appointment-declined-mpvi-codes/${action.payload.id}`,
            action.payload
          )
          .pipe(
            map(
              (declinedService: ServiceAppointmentDeclinedMpviCode) =>
                new UpdateSelectedAppointmentDeclinedMpviOnServerSuccess(declinedService)
            )
          );
      },
      onError: (action: UpdateSelectedAppointmentDeclinedMpviOnServer, error) => {
        console.error('Error', error);
      },
    }
  ));

  
  deleteSelectedAppointmentDeclinedMpviFromServer = createEffect(() => this.dataPersistence.pessimisticUpdate(
    ServiceAppointmentDeclinedOperationsEntityActionTypes.DeleteSelectedAppointmentDeclinedMpviFromServer,
    {
      run: (action: DeleteSelectedAppointmentDeclinedMpviFromServer, state: any) => {
        return this.apiService
          .delete<ServiceAppointmentDeclinedMpviCode>(
            `v/1/fixed-operations/service-appointment-declined-mpvi-codes/${action.payload.id}`,
            action.payload
          )
          .pipe(
            map(
              (declinedService: ServiceAppointmentDeclinedMpviCode) =>
                new DeleteSelectedAppointmentDeclinedMpviFromServerSuccess(declinedService)
            )
          );
      },
      onError: (action: DeleteSelectedAppointmentDeclinedMpviFromServer, error) => {
        console.error('Error', error);
      },
    }
  ));

  constructor(private dataPersistence: DataPersistence<any>, private apiService: ApiService) {}
}
